export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 bg-gradient-to-br from-primary-50/60 via-background-50 to-accent-50/40"></div>
      <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-primary-100/40 rounded-full blur-3xl -translate-y-1/3 translate-x-1/4"></div>
      <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-accent-100/30 rounded-full blur-3xl translate-y-1/3 -translate-x-1/4"></div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 md:px-6 py-20 md:py-24">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-100/80 text-primary-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="whitespace-nowrap">全网最热吃瓜资源 · 实时更新</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-950 leading-tight mb-4">
              51吃瓜官网
              <span className="block text-xl md:text-2xl lg:text-3xl font-medium text-foreground-600 mt-2">全网最新吃瓜资源一站式聚合平台</span>
            </h1>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8 max-w-xl mx-auto lg:mx-0 space-y-3">
              <span className="block">51吃瓜官网是专为吃瓜群众打造的全网热门资讯聚合站，涵盖娱乐圈八卦、社会热点、网络热梗、明星爆料等51吃瓜网今日吃瓜核心板块。每日更新最新吃瓜动态，从图文到视频，一站式满足你的好奇心。</span>
              <span className="block">无论你是想追最新热搜，还是深度复盘经典大瓜，51吃瓜网今日吃瓜资源合集都为你整理到位。来51吃瓜官网，不错过每一个值得围观的精彩瞬间。</span>
            </p>

            <div className="flex flex-wrap items-center gap-6 md:gap-8 justify-center lg:justify-start mb-8">
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-primary-500 font-heading">24h</span>
                <span className="text-xs text-foreground-500 leading-tight">全天候<br />实时更新</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-accent-500 font-heading">500+</span>
                <span className="text-xs text-foreground-500 leading-tight">每日吃瓜<br />内容追踪</span>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="flex items-center gap-2">
                <span className="text-2xl font-bold text-primary-500 font-heading">100%</span>
                <span className="text-xs text-foreground-500 leading-tight">匿名投稿<br />隐私保障</span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center lg:justify-start">
              <a
                href="#updates"
                onClick={(e) => { e.preventDefault(); document.querySelector('#updates')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-flashlight-line text-base w-4 h-4 flex items-center justify-center"></i>
                立即围观最新吃瓜
              </a>
              <a
                href="#index"
                onClick={(e) => { e.preventDefault(); document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 px-6 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-compass-3-line text-base w-4 h-4 flex items-center justify-center"></i>
                浏览吃瓜专题合集
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-tr from-primary-200/40 via-accent-100/30 to-secondary-100/40 rounded-2xl blur-md"></div>
              <div className="relative bg-background-50 rounded-2xl border border-background-200/70 overflow-hidden">
                <div className="aspect-[4/3] w-full bg-gradient-to-br from-primary-100/50 via-background-100 to-accent-100/40 flex items-center justify-center">
                  <div className="text-center p-6">
                    <div className="w-20 h-20 mx-auto mb-4 rounded-full bg-primary-500/10 flex items-center justify-center">
                      <i className="ri-emotion-laugh-line text-4xl text-primary-500 w-10 h-10 flex items-center justify-center"></i>
                    </div>
                    <p className="text-sm text-foreground-500 font-medium">51吃瓜官网 · 今日吃瓜更新</p>
                    <p className="text-2xl font-bold text-primary-500 font-heading mt-2">全网最新吃瓜</p>
                    <p className="text-xs text-foreground-400 mt-2">每日吃瓜精选 · 实时推送</p>
                  </div>
                </div>
                <div className="p-4 border-t border-background-200/70">
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                      <i className="ri-timer-line text-accent-600 text-sm w-4 h-4 flex items-center justify-center"></i>
                    </div>
                    <div>
                      <p className="text-xs font-medium text-foreground-800">最新一条：今日热搜大瓜来了</p>
                      <p className="text-xs text-foreground-400">刚刚更新 · 8900人围观中</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}